import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './CreateGroupPage.css'

const Next = ({ label, onClick }) => (
  <a onClick={onClick} className={styles.next}>
    <FormattedMessage id={label || 'group.create.next'} />
  </a>
)

export default Next
